module.exports = __webpack_public_path__ + "static/media/WHIL.1f935f77.svg";